const StorageEnum = {
  SEARCH_HISTORY: 'search_history',
  PROVIDER_SEARCH_HISTORY: 'provider_search_history',
  GAME_VOTED: 'game_voted',
};

Object.freeze(StorageEnum);

export default StorageEnum;
